/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ApiErrorProps } from "../../../types/ApiErrorType";
import {
  createQuoteOnQuestion,
  getQuoteData,
  saveQuestionDataBFF,
  sessionCheck,
  updateQuoteOnQuestion,
} from "../quote/quote.action";
import { submitWithdrawalRequestAction } from "../withdrawal/withdrawal.action";

const initialState: ApiErrorProps = {
  httpCode: null,
  errorCode: "",
  errorMessage: "",
  errorStatus: false,
  errors: null,
  modalTitle: "",
  modalDescription: "",
  ctaPrimaryBtnLabel: "",
  ctaSecondaryBtnLabel: "",
  multiButton: false,
  isCloseIconEnabled: true,
  contactNumber: "+34952010057",
  redirectPath: undefined,
};

const mergeDefaultProps = (payload: ApiErrorProps) => ({
  ...initialState,
  ...payload,
});

const apiError = createSlice({
  name: "apiError",
  initialState,
  reducers: {
    setApiError: (state, action: PayloadAction<typeof initialState>) => {
      return mergeDefaultProps(action.payload);
    },

    clearApiError: () => {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuoteData.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      })
      .addCase(createQuoteOnQuestion.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      })
      .addCase(updateQuoteOnQuestion.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      })
      .addCase(saveQuestionDataBFF.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      })
      .addCase(sessionCheck.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      })
      .addCase(submitWithdrawalRequestAction.rejected, (state, action) => {
        state = mergeDefaultProps(action.payload as ApiErrorProps);
        return state;
      });
  },
});

export const { setApiError, clearApiError } = apiError.actions;
export default apiError.reducer;
